module.exports = "/src/views/player/captures/assets/double-arrow.svg";